import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _archive = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _audio = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _audioV2 = { assets: '_audio' };
var _document = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _faceRecognition = { confidence: 'DOUBLE' };
var _fileDescriptor = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastUsedDate: 'google.protobuf.Timestamp',
    media: '_fileMedia',
};
var _fileMedia = {
    image: '_imageMedia',
    video: '_videoV2',
    audio: '_audioV2',
    document: '_document',
    vector: '_imageMedia',
    archive: '_archive',
    model3d: '_model3D',
};
var _getSiteStorageRequest = {};
var _getSiteStorageResponse = {
    updatedDate: 'google.protobuf.Timestamp',
    quota: '_totalQuota',
};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageMedia = {
    image: '_image',
    faces: '_faceRecognition',
    previewImage: '_image',
};
var _listStorageFilesRequest = {
    fromUpdatedDate: 'google.protobuf.Timestamp',
    toUpdatedDate: 'google.protobuf.Timestamp',
};
var _listStorageFilesResponse = { files: '_fileDescriptor' };
var _model3D = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    thumbnail: '_image',
};
var _plan = {
    createdAt: 'google.protobuf.Timestamp',
    expiresAt: 'google.protobuf.Timestamp',
};
var _plans = { premium: '_plan' };
var _totalQuota = { timestamp: 'google.protobuf.Timestamp', plans: '_plans' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveComWixMediaSiteMediaV1StorageServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-privatemedia-proxy-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-privatemedia-proxy-server/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/site-media/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of files in the Media Manager.
 *
 * To retrieve a list of files from all the folders in the Media Manager
 */
export function listStorageFiles(payload) {
    var _a = serializer(_listStorageFilesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listStorageFilesResponse, {
        _archive: _archive,
        _audio: _audio,
        _audioV2: _audioV2,
        _document: _document,
        _faceRecognition: _faceRecognition,
        _fileDescriptor: _fileDescriptor,
        _fileMedia: _fileMedia,
        _image: _image,
        _imageMedia: _imageMedia,
        _model3D: _model3D,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listStorageFiles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.storage_info',
            method: 'GET',
            methodFqn: 'com.wix.media.site_media.v1.StorageService.ListStorageFiles',
            url: resolveComWixMediaSiteMediaV1StorageServiceUrl({
                protoPath: '/v1/storage/files',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listStorageFiles.fromReq = fromReq;
    __listStorageFiles.__isAmbassador = true;
    return __listStorageFiles;
}
/** Get information about the site storage */
export function getSiteStorage(payload) {
    var _a = serializer(_getSiteStorageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSiteStorageResponse, {
        _plan: _plan,
        _plans: _plans,
        _totalQuota: _totalQuota,
    }).fromJSON;
    function __getSiteStorage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.storage_info',
            method: 'GET',
            methodFqn: 'com.wix.media.site_media.v1.StorageService.GetSiteStorage',
            url: resolveComWixMediaSiteMediaV1StorageServiceUrl({
                protoPath: '/v1/storage/storage-info',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSiteStorage.fromReq = fromReq;
    __getSiteStorage.__isAmbassador = true;
    return __getSiteStorage;
}
//# sourceMappingURL=http.impl.js.map